const hi = {
  nav: {
    home: "घर",
    about: "हमारे बारे में",
    destinations: "स्थल",
    tours: "पर्यटन एवं पैकेज",
    gallery: "गैलरी",
    testimonials: "प्रशंसापत्र",
    blog: "ब्लॉग",
    contact: "हमसे संपर्क करें",
    experiences: "अनुभव",
    vip: "वीआईपी बिजनेस",
    vipFull: "वीआईपी व्यापार यात्रा",
    worldcup: "विश्व कप 2030",
    careers: "करियर",
    chatWhatsApp: "व्हाट्सएप पर चैट करें",
    jewishHeritage: "कोषेर यात्रा",
    menu: "मेनू"
  },
  hero: {
    welcome: "मोरक्को में आपका स्वागत है।",
    welcomeHome: "सुस्वागतम्।",
    subtitle: "निजी लक्जरी पर्यटन, प्रामाणिक अनुभव,",
    subtitleLine2: "और पूरे मोरक्को में पूर्ण व्यक्तिगत सेवा -",
    subtitleGold: "सीईओ द्वारा व्यक्तिगत रूप से संभाला गया।",
    whatsappBtn: "व्हाट्सएप पर अब इलान (सीईओ) के साथ चैट करें",
    badgeFast: "त्वरित प्रतिक्रिया",
    badgePersonal: "व्यक्तिगत सेवा",
    badge247: "24/7 उपलब्धता",
    limitedAvail: "सीमित उपलब्धता",
    personalizedOnly: "केवल वैयक्तिकृत यात्राएँ"
  },
  strip: {
    privateTours: "निजी पर्यटन",
    localExperts: "स्थानीय विशेषज्ञ",
    bestHotels: "सर्वोत्तम होटल",
    luxuryTransport: "विलासिता परिवहन",
    satisfaction: "100% संतुष्टि"
  },
  cta: {
    whatsapp: "व्हाट्सएप पर अब इलान (सीईओ) के साथ चैट करें",
    whatsappFloating: "व्हाट्सएप पर चैट करें",
    whatsappInquiry: "नमस्ते, मुझे प्रीमियम मोरक्को यात्रा अनुभव में दिलचस्पी है।"
  },
  home: {
    vipBannerTitle: "वीआईपी मोरक्को यात्रा अनुभव",
    vipBannerText: "समझदार यात्रियों के लिए विशिष्ट पहुंच, निजी ड्राइवर और लक्जरी आवास।",
    vipBannerBtn: "वीआईपी सेवाएँ खोजें",
    wcBadge: "🇲🇦मोरक्को विश्व कप 2030",
    wcTitle: "मोरक्को 2030",
    wcText: "फुटबॉल, मोरक्कन संस्कृति, वीआईपी आतिथ्य और लक्जरी अनुभवों का संयोजन करने वाले विशेष विश्व कप यात्रा पैकेज।",
    wcBtn: "पैकेज देखें",
    galleryTitle: "गैलरी",
    gallerySubtitle: "आपकी भावी मोरक्कन यात्रा की एक झलक",
    exploreDestination: "गंतव्य का अन्वेषण करें",
    featuredToursTitle: "विशेष पर्यटन एवं पैकेज",
    featuredToursSubtitle: "संपूर्ण मोरक्कन साहसिक कार्य के लिए सावधानीपूर्वक संकलित अनुभव",
    viewAllTours: "सभी यात्राएँ देखें",
    culinaryTitle: "हमारा खाना - दुनिया में सबसे अच्छा",
    culinarySubtitle: "मोरक्कन पाककला उत्कृष्टता का अनुभव करें 🍲",
    culinaryBtn: "पाक संबंधी अनुभवों की खोज करें",
    culinaryIntro: "मोरक्को लव्स यू में, भोजन करना केवल खाने के बारे में नहीं है। यह मोरक्को की संस्कृति के केंद्र में एक यात्रा है। हम प्रामाणिक, हाथ से चुने गए पाक अनुभव प्रदान करते हैं - पारंपरिक घर के बने भोजन से लेकर उच्च-स्तरीय मोरक्कन गैस्ट्रोनॉमी तक, सभी प्यार और सबसे ताज़ी स्थानीय सामग्री से तैयार किए गए हैं।",
    culinaryVideoTitle: "पाक अनुभव वीडियो",
    culinaryFeatures: [
      "पारंपरिक टैगाइन",
      "प्रामाणिक कूसकस",
      "मोरक्कन पेस्ट्री",
      "चाय समारोह",
      "पाक - कला कक्षाएं",
      "स्थानीय मसाले",
      "जैविक सामग्री",
      "घर का बना भोजन"
    ],
    videoTitle: "सिफारिशों",
    unityQuote: "मोरक्को लव्स यू सभी संस्कृतियों, सभी मान्यताओं और सभी लोगों का स्वागत करता है।",
    unityAlt: "मोरक्को आपसे प्यार करता है एकता बैनर",
    testimonialsTitle: "हमारे वीआईपी मेहमान क्या कहते हैं",
    testimonialsSubtitle: "अंतर्राष्ट्रीय यात्रियों की वास्तविक समीक्षाएँ",
    readMoreReviews: "अधिक समीक्षाएँ पढ़ें",
    viewAllTransport: "सभी परिवहन देखें",
    transportTitle: "हमारे वीआईपी परिवहन और ड्राइवर",
    transportSubtitle: "पूरे मोरक्को में विलासिता, आराम और सुरक्षा 🌍",
    transportIntro: "मोरक्को लव्स यू में, परिवहन का अर्थ केवल एक स्थान से दूसरे स्थान तक जाना नहीं है। यह अनुभव का हिस्सा है. हम पूरे मोरक्को में आधुनिक, स्वच्छ, आरामदायक और पूरी तरह से वातानुकूलित वाहन प्रदान करते हैं - पेशेवर ड्राइवरों, गर्मजोशी भरे आतिथ्य और पहले क्षण से वीआईपी सेवा के साथ।"
  },
  tours: {
    pageTitle: "पर्यटन एवं पैकेज",
    pageSubtitle: "हमारे सावधानीपूर्वक तैयार किए गए मोरक्को टूर पैकेज में से चुनें",
    sectionTitle: "हमारे टूर पैकेज",
    sectionIntro: "रेगिस्तान के रोमांच से लेकर तटीय पलायन तक, हमारे पास हर यात्री के लिए उत्तम पैकेज है",
    howToBook: "कैसे बुक करें",
    step1Title: "एक यात्रा चुनें",
    step1Text: "हमारे पैकेज ब्राउज़ करें और जो आपके लिए सबसे उपयुक्त हो उसे चुनें",
    step2Title: "अभी बुक करें पर क्लिक करें",
    step2Text: "अपने चुने हुए दौरे पर \"अभी बुक करें\" बटन पर क्लिक करें",
    step3Title: "विवरण भरें",
    step3Text: "अपनी यात्रा की तारीखें और व्यक्तिगत जानकारी प्रदान करें",
    step4Title: "पुष्टीकरण",
    step4Text: "ईमेल के माध्यम से पुष्टिकरण और यात्रा कार्यक्रम विवरण प्राप्त करें",
    customTitle: "एक कस्टम पैकेज की आवश्यकता है?",
    customText: "व्यक्तिगत मोरक्को दौरे का अनुभव बनाने के लिए हमसे संपर्क करें",
    customBtn: "संपर्क में रहो",
    days: "दिन",
    highlights: "मुख्य विशेषताएं:",
    bookNow: "अभी बुक करें",
    highlightsLabel: "मुख्य अंश:",
    viewFullDetails: "पूर्ण विवरण देखें",
    viewDetails: "विवरण देखें",
    premiumPackage: "प्रीमियम पैकेज",
    arrival: "आगमन:",
    route: "मार्ग:",
    flights: "उड़ानें:",
    transportation: "परिवहन:",
    hotels: "होटल:",
    foodDining: "भोजन एवं भोजन:",
    whatsIncluded: "क्या शामिल है:",
    attractionsExperiences: "आकर्षण एवं अनुभव:",
    itinerary: "यात्रा कार्यक्रम:",
    optionalExperiences: "वैकल्पिक अनुभव:",
    availableUponRequest: "अनुरोध पर उपलब्ध:",
    specialSaharaExperience: "विशेष सहारा अनुभव:",
    suitableFor: "इसके लिए उपयुक्त:",
    importantNotes: "महत्वपूर्ण टिप्पणियाँ:",
    priceInformation: "कीमत की जानकारी:",
    priceWarningText: "उड़ान की कीमतों, विनिमय दरों, छुट्टियों, मौसम और होटल की उपलब्धता के आधार पर कीमतें बदल सकती हैं।",
    safetyComfort: "सुरक्षा एवं आराम:",
    safetyText: "हम अपने मेहमानों की सुरक्षा और आराम सुनिश्चित करने के लिए मोरक्को के अधिकारियों और सुरक्षा सेवाओं के साथ समन्वय में काम करते हैं।",
    safetyTextBrief: "आपकी सुरक्षा के लिए मोरक्को के अधिकारियों के साथ समन्वय किया गया।",
    givesMore: "मोरक्को तुम्हें प्यार करता है और अधिक देता है:",
    givesMoreText: "अधिक प्यार, देखभाल, व्यावसायिकता, आनंद और सुरक्षा। वास्तविक मानवीय आतिथ्य के साथ आसान और आरामदायक यात्राएँ।",
    givesMoreBrief: "मोरक्को आपसे प्यार करता है:",
    givesMoreTextBrief: "अधिक प्यार, देखभाल और व्यावसायिकता।",
    bookThisPackage: "यह पैकेज बुक करें",
    backToPackages: "पैकेज़ पर वापस जाएँ",
    premiumMoroccoPackages: "प्रीमियम मोरक्को पैकेज",
    premiumMoroccoPackagesDesc: "हमारे समझदार मेहमानों के लिए विशेष, सावधानीपूर्वक तैयार किए गए अनुभव।",
    suitable: {
      couples: "युगल",
      families: "परिवार",
      groups: "समूह",
      solo: "अकेले यात्री",
      seniors: "वरिष्ठ",
      companies: "कंपनियों",
      agencies: "ट्रैवल एजेंसियां",
      operators: "टूर ऑपरेटर"
    },
    pkg1: {
      title: "यूरोप/मोरक्को लक्जरी सप्ताहांत पलायन",
      duration: "3 रातें / 4 दिन",
      price: "€790",
      hl1: "सीधी राउंडट्रिप उड़ानें शामिल (लंदन/यूरोप)",
      hl2: "4-5 सितारा लक्जरी होटल",
      hl3: "पारंपरिक मोरक्कन हम्माम",
      hl4: "पाक कला एवं कला कार्यशालाएँ",
      hl5: "मोरक्कन लाइव प्रदर्शन",
      hl1_brief: "सीधी राउंडट्रिप उड़ानें शामिल हैं",
      subtitle: "सर्व-समावेशी पैकेज - ए से ज़ेड तक",
      flight1: "सीधी राउंडट्रिप उड़ानें",
      flight2: "20 किलो चेक किया हुआ सामान",
      flight3: "8 किलो तक का केबिन सामान",
      inc1: "हवाई अड्डे से पिकअप और वापसी",
      inc2: "4-5 सितारा होटल (हाफ बोर्ड)",
      inc3: "ताजा और प्रामाणिक मोरक्कन व्यंजन",
      inc4: "पारंपरिक चाय और पेस्ट्री का अनुभव",
      inc5: "पेशेवर टूर गाइड और निजी ड्राइवर",
      inc6: "आधुनिक वातानुकूलित परिवहन",
      inc7: "विशेष लाइव प्रदर्शन (गायक और नर्तक)",
      inc7_brief: "विशेष लाइव प्रदर्शन",
      inc8: "पारंपरिक बाज़ार भ्रमण (मसाला, लालटेन, कालीन)",
      inc8_brief: "पारंपरिक बाज़ार भ्रमण",
      inc9: "पाक कला एवं कला कार्यशालाएँ (पूर्व-बुकिंग आवश्यक)",
      inc9_brief: "पाक कला एवं कला कार्यशालाएँ",
      inc10: "प्राकृतिक झरनों और दृश्य बिंदुओं का दौरा",
      inc11: "शेफचौएन और इफ्रेन की दिन यात्राएँ",
      inc12: "स्थानीय मोरक्कन परिवारों से मुलाकात",
      inc13: "भ्रमण के दौरान आश्चर्यजनक अनुभव",
      suit1: "युगल",
      suit2: "परिवार",
      suit3: "समूह",
      suit4: "अकेले यात्री",
      suit5: "वरिष्ठ",
      suit6: "कंपनियों",
      suit7: "ट्रैवल एजेंसियां",
      suit8: "टूर ऑपरेटर"
    },
    pkg2: {
      title: "मोरक्को लक्ज़री डिस्कवरी टूर",
      duration: "6 रातें / 7 दिन",
      price: "€1490",
      hl1: "पैकेज ए",
      hl2: "एटलस मूवमेंट्स",
      hl3: "माराकेच- एस्साओइरा - मेरज़ौगा - उआर्ज़ाज़्टे - माराकेच-",
      hl4: "बड़ा आश्चर्य ❤️",
      hl5: "पैकेज बी",
      subtitle: "फ़ेस और उत्तरी मोरक्को मार्ग (सभी समावेशी)",
      routeText: "2 रातें फेस, 1 रात शेफचौएन, 1 रात टैंजियर, 1 रात इफ्रेन, 1 अंतिम रात फेस",
      flight1: "यूरोप से सीधी राउंडट्रिप उड़ानें",
      flight2: "20 किलो सामान + केबिन सामान",
      trans1: "हवाई अड्डे से पिकअप एवं स्थानांतरण",
      trans2: "निजी पेशेवर ड्राइवर और टूर गाइड",
      trans3: "नये वातानुकूलित वाहन",
      hotel1: "4-5 सितारा होटल",
      hotel2: "प्रीमियम स्थान",
      hotel3: "उच्च स्तरीय सेवा",
      food1: "समुचित व्यवस्था",
      food2: "प्रामाणिक व्यंजन",
      food3: "पारंपरिक चाय और पेस्ट्री",
      exp1: "मोरक्कन लाइव प्रदर्शन",
      exp2: "पारंपरिक बाज़ार (मसाला, लालटेन, कालीन)",
      exp2_brief: "पारंपरिक बाज़ार",
      exp3: "पारंपरिक मोरक्कन हम्माम",
      exp4: "प्रकृति एवं वन भ्रमण",
      exp4_brief: "प्रकृति भ्रमण",
      exp5: "खूबसूरत नज़ारे और दिन की यात्राएँ",
      exp6: "पाक कला एवं कला कार्यशालाएँ",
      exp7: "स्थानीय परिवारों से मुलाकात",
      exp8: "यात्रा के दौरान विशेष आश्चर्य",
      suit1: "युगल",
      suit2: "परिवार",
      suit3: "समूह",
      suit4: "अकेले यात्री",
      suit5: "वरिष्ठ",
      suit6: "कंपनियों",
      suit7: "ट्रैवल एजेंसियां"
    },
    pkg3: {
      title: "मोरक्को ग्रैंड अनुभव",
      duration: "10 रातें / 11 दिन",
      price: "€1990",
      hl1: "पूर्ण प्रीमियम ग्राउंड सेवाएँ",
      hl2: "कैसाब्लांका, माराकेच और फेस",
      hl3: "अगाडिर और सहारा रेगिस्तान आश्चर्य",
      hl4: "उआर्ज़ाज़ेट और शेफचौएन पर जाएँ",
      hl5: "विशेष लाइव संगीत और प्रदर्शन",
      subtitle: "✨ मोरक्को ग्रैंड एक्सपीरियंस (केवल ग्राउंड सर्विसेज)",
      arrivalText: "कैसाब्लांका या माराकेच",
      routeText: "कैसाब्लांका, रबात, 2 रातें फ़ेस, टैंजियर, शेफचौएन, इफ्रेन, 2 रातें माराकेच, अगाडिर, उआरज़ाज़ेट, अंतिम रात माराकेच",
      note2: "समूह > 40: प्रति व्यक्ति $50 की विशेष छूट",
      note3: "अंतर्राष्ट्रीय उड़ानें और बीमा शामिल नहीं हैं",
      note4: "ड्राइवर/गाइड के लिए युक्तियाँ शामिल नहीं हैं",
      inc1: "पूर्ण प्रीमियम ग्राउंड सेवाएँ",
      inc2: "4-5 सितारा होटल (हाफ बोर्ड)",
      inc3: "पेशेवर टूर गाइड और निजी ड्राइवर",
      inc4: "वातानुकूलित बस या मिनीबस",
      inc5: "लाइव प्रदर्शन और संगीत का माहौल",
      inc6: "पारंपरिक बाज़ार और हम्माम का दौरा",
      inc7: "पाक कला एवं कला कार्यशालाएँ",
      inc8: "जंगलों, झरनों और दृष्टिकोणों का भ्रमण",
      inc9: "स्थानीय परिवारों से मुलाकात",
      inc10: "यात्रा के दौरान विशेष आश्चर्य"
    },
    pkg4: {
      title: "लक्जरी मोरक्को अनुभव",
      duration: "16 रातें/17 दिन",
      price: "सभी समावेशी",
      hl1: "कैसाब्लांका • रबात • फ़ेज़ • टैंजियर • शेफचौएन",
      hl2: "इफ्रेन • मर्ज़ौगा सहारा रेगिस्तान",
      hl3: "एस्सौइरा • ओरिका और एटलस पर्वत • मराकेश",
      hl3_brief: "एटलस पर्वत पर जाएँ",
      hl4: "ऊँट और जीप पर्यटन के साथ 2 रातों का लक्ज़री डेजर्ट कैंप",
      hl5: "जादुई सूर्योदय और सूर्यास्त • तारों के नीचे सोएं",
      subtitle: "✨ मोरक्को इंपीरियल और सहारा अनुभव - पूरी यात्रा (16 रातें / 17 दिन)",
      routeText: "कैसाब्लांका (1 रात), रबात, फ़ेज़ (2 रातें), टैंजिएर (1 रात), शेफचौएन (1 रात), इफ्रेन (1 रात), मेरज़ौगा सहारा (2 रातें), एस्सौइरा (2 रातें), ओरिका और एटलस पर्वत (1 रात), मराकेश (3 रातें)",
      inc1: "4★ / 5★ होटल",
      inc2: "लक्जरी वातानुकूलित डेजर्ट कैंप",
      inc2_brief: "4-5 सितारा होटल",
      inc3: "पूर्ण बोर्ड/प्रीमियम मोरक्कन व्यंजन",
      inc3_brief: "पेशेवर टूर गाइड",
      inc4: "व्यावसायिक बहुभाषी मार्गदर्शिकाएँ",
      inc4_brief: "विशेष लाइव प्रदर्शन",
      inc5: "निजी आधुनिक परिवहन",
      inc5_brief: "पारंपरिक बाज़ार",
      inc6: "वातानुकूलित कोच",
      inc7: "बोर्ड पर वाईफाई • टीवी • रेफ्रिजरेटर",
      inc8: "पूरे दौरे के दौरान निजी ड्राइवर",
      inc9: "ऊँट भ्रमण",
      inc10: "जीप रेगिस्तान का अनुभव",
      inc11: "लोकगीत शो और लाइव संगीत",
      inc12: "मोरक्कन नृत्य प्रदर्शन",
      inc13: "खाना पकाने की कार्यशालाएँ",
      inc14: "बाज़ार और सूक्स अनुभव",
      inc15: "कालीन • मसाले • फूल • पारंपरिक शिल्प",
      inc16: "झीलें • नदियाँ • एटलस पर्वत",
      inc17: "विशेष सूर्योदय एवं सूर्यास्त अनुभव",
      inc18: "प्रत्यक्ष 24/7 सहायता",
      optional1: "गर्म हवा के गुब्बारे का अनुभव",
      optional2: "वीआईपी उन्नयन",
      optional3: "विलासितापूर्ण अनुभव",
      optional4: "निजी सुरक्षा सेवाएँ",
      optional5: "चिकित्सा सहायता सेवाएँ",
      optionalNote: "कुछ प्रीमियम सेवाओं के लिए अतिरिक्त उचित अनुपूरक की आवश्यकता हो सकती है।",
      sahara1: "प्रीमियम वातानुकूलित डेजर्ट टेंट",
      sahara2: "कैम्प फायर संगीत का माहौल",
      sahara3_brief: "जीप भ्रमण और ऊँट की सवारी",
      itinerary1: "कैसाब्लांका - आगमन (1 रात)",
      itinerary2: "रबात - शाही राजधानी",
      itinerary3: "फ़ेज़ - आध्यात्मिक और सांस्कृतिक मोरक्को (2 रातें)",
      itinerary4: "टैंजियर - जहां यूरोप अफ्रीका से मिलता है (1 रात)",
      itinerary5: "शेफचौएन - द ब्लू पर्ल (1 रात)",
      itinerary6: "इफ्रेन - मोरक्कन स्विट्जरलैंड (1 रात)",
      itinerary7: "मेरज़ौगा सहारा रेगिस्तान (2 रातें) - लक्जरी रेगिस्तान शिविर - ऊंट अनुभव - जीप टूर - जादुई सूर्योदय और सूर्यास्त - सितारों के नीचे सोना",
      itinerary8: "एस्सौइरा - अटलांटिक महासागर एस्केप (2 रातें)",
      itinerary9: "ओरिका और एटलस पर्वत (1 रात)",
      itinerary10: "मराकेश - द रेड सिटी (3 रातें)"
    }
  },
  destinations: {
    pageTitle: "मोरक्को के गंतव्यों का अन्वेषण करें",
    pageSubtitle: "खूबसूरत मोरक्को में घूमने के लिए अविश्वसनीय स्थानों की खोज करें",
    sectionTitle: "सभी गंतव्य",
    sectionIntro: "मोरक्को विविध परिदृश्यों और समृद्ध सांस्कृतिक विरासत का देश है। हमारे सावधानीपूर्वक चयनित गंतव्यों का अन्वेषण करें:",
    exploreNow: "अभी अन्वेषण करें",
    ctaTitle: "क्या आप अपनी यात्रा की योजना बनाने के लिए तैयार हैं?",
    ctaText: "संपूर्ण मोरक्कन अनुभव पाने के लिए हमारे क्यूरेटेड टूर और पैकेज ब्राउज़ करें",
    ctaBtn: "टूर और पैकेज देखें"
  },
  experiences: {
    pageTitle: "मोरक्कन पाककला उत्कृष्टता",
    pageSubtitle: "हमारे भोजन की खोज करें - दुनिया में सबसे अच्छा",
    bookViaWhatsApp: "व्हाट्सएप के माध्यम से बुक करें",
    introTitle: "हमारा अनोखा मोरक्कन पाककला अनुभव",
    introHighlight: "प्रामाणिक स्वाद, ताज़ी सामग्री, सदियों की परंपरा और अविस्मरणीय आतिथ्य।",
    introP1: "मोरक्को के प्रामाणिक स्वादों में आपका स्वागत है।",
    introP2: "मोरक्को लव्स यू में, भोजन केवल एक भोजन नहीं है - यह संस्कृति, इतिहास, परिवार, आतिथ्य और प्रेम है।",
    introP3: "सदियों से, मोरक्कन व्यंजन को दुनिया के सबसे समृद्ध, स्वास्थ्यप्रद और सबसे स्वादिष्ट व्यंजनों में से एक माना जाता है।",
    introP4: "हमारी पाक परंपराएं अरब, बर्बर, यहूदी मोरक्कन, अंडालूसी, भूमध्यसागरीय और अफ्रीकी प्रभावों को जोड़ती हैं - 500 से अधिक वर्षों से संरक्षित अद्वितीय व्यंजनों का निर्माण करती हैं।",
    prepTitle: "मोरक्कन तैयारी की कला",
    prepP1: "सब कुछ देखभाल, जुनून, ताज़ा स्थानीय सामग्री और प्रामाणिक मोरक्कन मसालों के साथ तैयार किया जाता है।",
    prepP2: "हम अपने मेहमानों के लिए विश्वसनीय रेस्तरां, प्रामाणिक स्थानीय अनुभव और गुणवत्तापूर्ण पाक स्थलों का सावधानीपूर्वक चयन करते हैं।",
    prepP3: "मोरक्को अपने रंगीन बाज़ारों, ताज़ा कृषि, प्राकृतिक उत्पादों, मसालों, जैतून, संतरे, पेस्ट्री, पुदीना चाय और अविस्मरणीय आतिथ्य के लिए दुनिया भर में जाना जाता है।",
    journeyVideos: "पाक यात्रा वीडियो",
    highlightsTitle: "पारंपरिक पाककला की मुख्य विशेषताएं",
    highlightTagine: "प्रामाणिक मोरक्कन टैगिन",
    highlightCouscous: "पारंपरिक कूसकूस",
    highlightVegetables: "ताज़ी सब्जियाँ और प्राकृतिक सामग्री",
    highlightPastries: "घर का बना पेस्ट्री और डेसर्ट",
    highlightBreakfasts: "पारंपरिक मोरक्कन नाश्ता",
    highlightMeat: "ताज़ी मछली और गुणवत्तापूर्ण मांस",
    highlightJuices: "प्राकृतिक रस और मोरक्कन चाय",
    highlightHealthy: "स्वस्थ और स्वादिष्ट खाना पकाने की परंपराएँ",
    galleryTitle: "हमारी पाक गैलरी",
    summaryP1: "हमारा लक्ष्य अपने मेहमानों को न केवल एक यात्रा - बल्कि एक सच्ची मोरक्कन पाक यात्रा की पेशकश करना है।",
    tagHealthy: "स्वस्थ",
    tagAuthentic: "प्रामाणिक",
    tagTraditional: "परंपरागत",
    tagFresh: "ताजा",
    tagUnique: "अद्वितीय",
    tagDelicious: "स्वादिष्ट",
    important: "महत्वपूर्ण:",
    guidanceNote: "सर्वोत्तम पाक अनुभव के लिए, हम मोरक्को में आपकी यात्रा के दौरान हमारी टीम के मार्गदर्शन और पाक संबंधी सिफारिशों का पालन करने की दृढ़ता से अनुशंसा करते हैं।",
    whereMeal: "जहां हर भोजन एक स्मृति बन जाता है।",
    whatsappLabel: "व्हाट्सएप: +972 54-633-8757",
    moroccoLine: "मोरक्को लाइन: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "वीआईपी और व्यावसायिक यात्रा",
    pageSubtitle: "सीईओ, निवेशकों और समझदार यात्रियों के लिए विशेष सेवाएँ",
    introTitle: "मोरक्को में निर्बाध उत्कृष्टता",
    introText: "MoroccoLovesYou व्यापारिक यात्रियों, कॉर्पोरेट प्रतिनिधिमंडलों और वीआईपी मेहमानों के लिए एक अद्वितीय मानक सेवा प्रदान करता है। हम समझते हैं कि आपका समय मूल्यवान है और आपके मानक अटल हैं। टचडाउन से लेकर प्रस्थान तक, हम प्रत्येक विवरण को सटीकता से संभालते हैं, जिससे आप अपने व्यावसायिक उद्देश्यों पर ध्यान केंद्रित कर सकते हैं और साथ ही हम एक त्रुटिहीन मोरक्कन अनुभव प्रदान करते हैं।",
    ctaTitle: "सीईओ तक सीधी पहुंच",
    ctaText: "तत्काल पूछताछ और अत्यधिक विशिष्ट अनुरोधों के लिए, सीधे हमारे संस्थापक और सीईओ, इलान हैचुएल से बात करें।",
    ctaBtn: "अब इलान से संपर्क करें",
    luxuryTransport: "विलासिता परिवहन",
    luxuryTransportDesc: "वीआईपी हवाई अड्डा स्थानान्तरण और निजी द्विभाषी ड्राइवर लक्जरी वाहनों (मर्सिडीज एस-क्लास, वी-क्लास) के साथ 24/7 उपलब्ध हैं।",
    premiumAccom: "प्रीमियम आवास",
    premiumAccomDesc: "अधिकारियों और उनकी टीमों के लिए उपयुक्त 5-सितारा होटल, लक्जरी रियाद या निजी विला में विशेष बुकिंग।",
    businessConcierge: "बिजनेस द्वारपाल",
    businessConciergeDesc: "पूर्ण बैठक सहायता, निजी भोजन आरक्षण, और कॉर्पोरेट रिट्रीट के लिए विशेष यात्रा कार्यक्रम।",
    securityPrivacy: "सुरक्षा एवं गोपनीयता",
    securityPrivacyDesc: "हाई-प्रोफाइल व्यक्तियों और मशहूर हस्तियों के लिए विवेकपूर्ण सेवा, सुरक्षित वातावरण और पूर्ण गोपनीयता।",
    support247: "24/7 सहायता",
    support247Desc: "सीईओ से सीधा संपर्क और आपके प्रवास के दौरान किसी भी समय आपकी सहायता के लिए तैयार एक समर्पित टीम।",
    customItineraries: "कस्टम यात्रा कार्यक्रम",
    customItinerariesDesc: "अनुकूलित यात्रा योजनाएं प्रीमियम मोरक्कन सांस्कृतिक अनुभवों के साथ आपके व्यावसायिक दायित्वों को पूरी तरह से संतुलित करती हैं।"
  },
  worldcup: {
    pageTitle: "मोरक्को 2030 विश्व कप",
    pageSubtitle: "सबसे बड़े फुटबॉल आयोजन के लिए विशेष वीआईपी पैकेज और यात्रा अनुभव",
    limitedBadge: "सीमित उपलब्धता",
    introTitle: "परम फुटबॉल यात्रा",
    introText: "2030 में, मोरक्को फीफा विश्व कप की सह-मेजबानी करेगा, जिससे दुनिया का सबसे प्रतिष्ठित खेल आयोजन उत्तरी अफ्रीका में आएगा। मोरक्कोलव्सयू उन प्रशंसकों के लिए डिज़ाइन किए गए विशेष, सर्व-समावेशी लक्जरी यात्रा पैकेज की पेशकश करने में गर्व महसूस करता है जो आराम, पहुंच और अनुभव में सर्वोत्तम की मांग करते हैं।",
    packagesTitle: "प्रीमियम विश्व कप पैकेज",
    silverTitle: "चांदी का पैकेज",
    silverSub: "आवश्यक अनुभव",
    goldTitle: "सोने का पैकेज",
    goldSub: "विलासितापूर्ण अनुभव",
    mostPopular: "सबसे लोकप्रिय",
    diamondTitle: "डायमंड वीआईपी",
    diamondSub: "परम अनुभव",
    inquireWhatsApp: "व्हाट्सएप के माध्यम से पूछताछ करें",
    ctaTitle: "कीमतें बढ़ने से पहले अपना स्थान सुरक्षित करें",
    ctaText: "अत्यधिक उच्च अंतरराष्ट्रीय मांग के कारण, हम आपके वीआईपी पैकेज को जल्दी सुरक्षित करने की अत्यधिक अनुशंसा करते हैं। मेजबान शहरों में आवास बिक ​​जायेंगे।",
    ctaBtn: "आज ही हमसे संपर्क करें",
    silverF1: "प्रीमियम रियाद / 4-सितारा होटल आवास",
    silverF2: "पूर्व नियोजित मैच दिवस रसद",
    silverF3: "निर्देशित शहर भ्रमण (मेजबान शहर)",
    silverF4: "24/7 समर्पित सहायता लाइन",
    goldF1: "5 सितारा होटल/लक्जरी विला आवास",
    goldF2: "निजी हवाई अड्डा एवं मैच स्थानान्तरण",
    goldF3: "वीआईपी डेजर्ट कैंप गेटअवे (2 दिन)",
    goldF4: "व्यक्तिगत द्विभाषी दरबान",
    diamondF1: "राष्ट्रपति सुइट्स/निजी महल",
    diamondF2: "24/7 निजी चालक एवं सुरक्षा",
    diamondF3: "वीआईपी आयोजनों और पार्टियों तक विशेष पहुंच",
    diamondF4: "प्रत्यक्ष सीईओ हैंडलिंग एवं वीवीआईपी द्वारपाल"
  },
  gallery: {
    pageTitle: "हमारी गैलरी",
    pageSubtitle: "अविस्मरणीय मोरक्कन यात्राओं की दृश्य यादें",
    picturesTitle: "तस्वीरों में मोरक्को",
    picturesIntro: "मोरक्को से लुभावनी तस्वीरों के हमारे संग्रह का अन्वेषण करें",
    videosTitle: "मोशन में मोरक्को",
    videosIntro: "हमारे क्यूरेटेड वीडियो संग्रह के माध्यम से मोरक्को का अनुभव लें",
    catFood: "पाककला अनुभव",
    catDestinations: "स्थल",
    catKosher: "कोषेर",
    catTransport: "वीआईपी परिवहन"
  },
  testimonials: {
    pageTitle: "अतिथि प्रशंसापत्र",
    pageSubtitle: "पढ़ें कि हमारे यात्री अपने मोरक्कन अनुभव के बारे में क्या कहते हैं",
    sectionTitle: "हमारे खुश यात्री",
    sectionIntro: "हजारों संतुष्ट मेहमानों ने हमारे साथ मोरक्को के जादू का अनुभव किया है",
    verifiedGuest: "सत्यापित अतिथि",
    ratingsTitle: "हमारी रेटिंग",
    avgRating: "औसत श्रेणी",
    verifiedReviews: "सत्यापित समीक्षाएँ",
    fromReal: "असली यात्रियों से",
    custSatisfaction: "ग्राहक संतुष्टि",
    wouldRecommend: "अनुशंसा करेंगे",
    shareTitle: "अपना अनुभव साझा करें",
    shareText: "हमारे साथ एक अद्भुत यात्रा रही? हमें इसके बारे में सुनना अच्छा लगेगा!",
    shareBtn: "हमें अपनी कहानी बताएं"
  },
  blog: {
    pageTitle: "यात्रा ब्लॉग",
    pageSubtitle: "आपके मोरक्कन साहसिक कार्य के लिए कहानियाँ, युक्तियाँ और मार्गदर्शिकाएँ",
    sectionTitle: "नवीनतम यात्रा लेख",
    sectionIntro: "मोरक्को में यात्रा, स्थानीय संस्कृति और अंदरूनी युक्तियों के बारे में हमारे नवीनतम लेख पढ़ें",
    readMore: "और पढ़ें →",
    by: "द्वारा",
    newsletterTitle: "हमारे न्युजलेटर की सदस्यता प्राप्त करें",
    newsletterText: "अपने इनबॉक्स में नवीनतम यात्रा युक्तियाँ और विशेष ऑफ़र प्राप्त करें",
    newsletterPlaceholder: "अपना ईमेल दर्ज करें",
    subscribe: "सदस्यता लें"
  },
  contact: {
    pageTitle: "हमसे 24/7 संपर्क करें",
    pageSubtitle: "अपने वीआईपी मोरक्को साहसिक कार्य की योजना बनाने के लिए हमारी टीम से संपर्क करें",
    getInTouch: "हमसे संपर्क करें",
    getInTouchText: "हम आपकी मदद करने और आपके किसी भी प्रश्न का उत्तर देने के लिए यहां हैं। हमारी टीम आपकी संपूर्ण मोरक्को यात्रा की योजना बनाने में आपकी सहायता करने के लिए तैयार है।",
    address: "हमारा पता",
    addressText: "53 मोहम्मद वी स्ट्रीट, फेस, मोरक्को",
    phone: "फ़ोन नंबर 📞",
    directPhone: "सीधा फ़ोन: +212 6 63 63 05 79",
    whatsappPhone: "व्हाट्सएप: +972 54 633 8757",
    email: "व्यावसायिक ईमेल पते",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Sales@MoroccoLovesYou.com",
      "Michel@MoroccoLovesYou.com",
      "किम@मोरक्कोलव्सयू.कॉम"
    ],
    businessHours: "काम करने के घंटे",
    businessHoursText: "24/7 उपलब्ध\nसप्ताह में 7 दिन",
    responseTime: "हम 48 घंटों के भीतर आपसे संपर्क करेंगे।",
    welcomeMessage: "मोरक्को में आपका स्वागत है 🇲🇦",
    followUs: "हमारे पर का पालन करें",
    formTitle: "हमें एक संदेश भेजें",
    successMessage: "✓ धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे.",
    firstName: "पहला नाम",
    lastName: "उपनाम",
    emailAddress: "मेल पता",
    phoneNumber: "फ़ोन नंबर",
    subject: "विषय",
    selectSubject: "एक विषय चुनें",
    tourInquiry: "यात्रा पूछताछ",
    bookingQuestion: "बुकिंग प्रश्न",
    customPackage: "कस्टम पैकेज",
    feedback: "प्रतिक्रिया",
    other: "अन्य",
    message: "विवरण/संदेश",
    sendMessage: "मेसेज भेजें",
    mapTitle: "हमें मानचित्र पर खोजें",
    faqTitle: "अक्सर पूछे जाने वाले प्रश्नों",
    faq1Q: "मोरक्को घूमने का सबसे अच्छा समय क्या है?",
    faq1A: "वसंत (अप्रैल-मई) और पतझड़ (सितंबर-अक्टूबर) सबसे अच्छा मौसम प्रदान करते हैं। रेगिस्तान में गर्मियाँ गर्म होती हैं, जबकि सर्दियाँ हल्की लेकिन बारिश वाली हो सकती हैं।",
    faq2Q: "क्या मुझे मोरक्को जाने के लिए वीज़ा की आवश्यकता है?",
    faq2A: "वीज़ा आवश्यकताएँ आपकी राष्ट्रीयता पर निर्भर करती हैं। कई देशों में 90 दिनों तक वीज़ा-मुक्त प्रवेश की सुविधा है। अपने स्थानीय दूतावास से जाँच करें।",
    faq3Q: "मोरक्को में किस मुद्रा का प्रयोग किया जाता है?",
    faq3A: "मोरक्कन दिरहम (एमएडी) आधिकारिक मुद्रा है। एटीएम शहरों में व्यापक रूप से उपलब्ध हैं, और अधिकांश स्थान क्रेडिट कार्ड स्वीकार करते हैं।",
    faq4Q: "मोरक्को में कौन सी भाषा बोली जाती है?",
    faq4A: "अरबी और बर्बर (अमाज़ी) आधिकारिक भाषाएँ हैं। फ्रेंच व्यापक रूप से बोली जाती है, और पर्यटन क्षेत्रों में अंग्रेजी तेजी से आम हो रही है।",
    faq5Q: "क्या मोरक्को पर्यटकों के लिए सुरक्षित है?",
    faq5A: "हाँ, मोरक्को आम तौर पर पर्यटकों के लिए सुरक्षित है। सामान्य ज्ञान संबंधी सावधानियां लागू होती हैं। हमारे मार्गदर्शक यह सुनिश्चित करते हैं कि आपको एक सुरक्षित और आनंददायक अनुभव मिले।",
    faq6Q: "क्या मैं अपना टूर पैकेज कस्टमाइज़ कर सकता हूँ?",
    faq6A: "बिल्कुल! हम आपकी रुचियों, बजट और यात्रा की तारीखों के अनुरूप कस्टम पैकेज पेश करते हैं। अपनी आवश्यकताओं पर चर्चा करने के लिए हमसे संपर्क करें।"
  },
  about: {
    pageTitle: "मोरक्को लव्स यू के बारे में",
    pageSubtitle: "मोरक्को के जादू की खोज में आपका भरोसेमंद साथी",
    storyTitle: "हमारी कहानी",
    storyP1: "MoroccoLovesYou की स्थापना एक सरल मिशन के साथ की गई थी: यात्रियों को मोरक्को की प्रामाणिक सुंदरता, संस्कृति और आतिथ्य का अनुभव करने में मदद करना। एक छोटी यात्रा गाइड सेवा के रूप में शुरू हुई यह एक व्यापक पर्यटन कंपनी बन गई है जो सालाना हजारों आगंतुकों को सेवा प्रदान करती है।",
    storyP2: "हमारी संस्थापक फातिमा हसन को मोरक्को से प्यार हो गया और वह इस जुनून को दुनिया के साथ साझा करना चाहती थीं। आज, हम वैयक्तिकृत, प्रामाणिक अनुभव बनाने पर गर्व करते हैं जो सामान्य पर्यटन से परे है।",
    missionTitle: "🎯हमारा मिशन",
    missionText: "असाधारण यात्रा अनुभव प्रदान करना जो स्थानीय समुदायों और टिकाऊ पर्यटन प्रथाओं का समर्थन करते हुए मोरक्को की समृद्ध सांस्कृतिक विरासत, आश्चर्यजनक परिदृश्य और गर्मजोशी भरे आतिथ्य को प्रदर्शित करता है।",
    visionTitle: "🌟 हमारा दृष्टिकोण",
    visionText: "मोरक्को की अग्रणी पर्यटन कंपनी बनना जो प्रामाणिकता, विश्वसनीयता और हमारे साथ इस शानदार देश का भ्रमण करने वाले हर यात्री के लिए अविस्मरणीय यादें बनाने के लिए जानी जाती है।",
    whyTitle: "मोरक्को लव्स यू क्यों चुनें?",
    expertTitle: "विशेषज्ञ ज्ञान",
    expertText: "हमारी टीम को मोरक्को के बारे में व्यापक जानकारी है और वह वैयक्तिकृत सिफ़ारिशें प्रदान करती है।",
    localTitle: "स्थानीय कनेक्शन",
    localText: "वास्तविक अनुभव सुनिश्चित करने के लिए हम प्रामाणिक स्थानीय गाइडों और परिवारों के साथ काम करते हैं।",
    valueTitle: "सबसे अच्छा मूल्य",
    valueText: "गुणवत्ता और अनुभव से समझौता किए बिना प्रतिस्पर्धी मूल्य निर्धारण।",
    safetyTitle: "सुरक्षा एवं सहायता",
    safetyText: "24/7 ग्राहक सहायता और व्यापक यात्रा बीमा शामिल है।",
    sustainTitle: "स्थायी पर्यटन",
    sustainText: "हम स्थानीय समुदायों का समर्थन करते हैं और जिम्मेदार पर्यटन का अभ्यास करते हैं।",
    bookingTitle: "आसान बुकिंग",
    bookingText: "लचीले भुगतान विकल्पों के साथ सरल ऑनलाइन बुकिंग प्रक्रिया।",
    teamTitle: "हमारी टीम",
    teamSubtitle: "MoroccoLovesYou के पीछे के जोशीले लोगों से मिलें",
    happyTravelers: "खुश यात्री",
    yearsExp: "वर्षों का अनुभव",
    destinationsCount: "स्थल",
    satisfactionRate: "संतुष्टि दर"
  },
  footer: {
    description: "हमारे साथ मोरक्को के जादू की खोज करें। अविस्मरणीय रोमांच का अनुभव करें और स्थायी यादें बनाएं।",
    quickLinks: "त्वरित सम्पक",
    more: "अधिक",
    contactInfo: "संपर्क सूचना",
    copyright: "© 2024 मोरक्को तुम्हें प्यार करता है। सर्वाधिकार सुरक्षित।"
  },
  starBanner: {
    ceoMessage: "सीईओ संदेश",
    watchVideo: "मेरा वीडियो देखें",
    readMessage: "और मेरा संदेश पढ़ें",
    getToKnow: "जानें",
    ilanPersonally: "इलान व्यक्तिगत रूप से"
  },
  tourMini: {
    days: "10 दिन",
    nights: "/ 9 रातें",
    title: "प्रीमियम मोरक्को\nभ्रमण",
    years: "2026 - 2027",
    departures: "मासिक प्रस्थान",
    allIncluded: "सभी शामिल\nपूर्ण बोर्ड",
    recommendations: "सिफारिशों",
    recCount: "500+ खुश यात्री"
  },
  cityDetail: {
    notFound: "शहर नहीं मिला",
    backHome: "घर वापिस जा रहा हूँ",
    discoverSubtitle: "सौंदर्य और संस्कृति की खोज करें",
    planTrip: "मेरी यात्रा की योजना बनाएं",
    galleryOf: "की गैलरी",
    bookExperience: "इस अनुभव को बुक करें",
    requestItinerary: "पूर्ण यात्रा कार्यक्रम का अनुरोध करें",
    readyToVisit: "यात्रा के लिए तैयार",
    readyToVisitText: "आइए हम इस अद्भुत गंतव्य के लिए आपकी संपूर्ण यात्रा की योजना बनाएं",
    planMyTrip: "मेरी यात्रा की योजना बनाएं",
    talkExpert: "किसी विशेषज्ञ से बात करें"
  },
  transportation: {
    pageTitle: "वीआईपी परिवहन और ड्राइवर",
    pageSubtitle: "पूरे मोरक्को में विलासिता, आराम और सुरक्षा",
    introTitle: "हमारे वीआईपी परिवहन और ड्राइवर",
    introP1: "मोरक्को लव्स यू में, परिवहन का अर्थ केवल एक स्थान से दूसरे स्थान तक जाना नहीं है।",
    introP2: "यह अनुभव का हिस्सा है.",
    introP3: "हम पूरे मोरक्को में आधुनिक, स्वच्छ, आरामदायक और पूरी तरह से वातानुकूलित वाहन प्रदान करते हैं - पेशेवर ड्राइवरों, गर्मजोशी भरे आतिथ्य और पहले क्षण से वीआईपी सेवा के साथ।",
    introP4: "चाहे आप जोड़े, परिवार, व्यावसायिक प्रतिनिधिमंडल या निजी समूह के रूप में यात्रा करें, हम सुनिश्चित करते हैं कि आपकी यात्रा सुरक्षित, आरामदायक और अविस्मरणीय हो।",
    servicesTitle: "हमारी परिवहन सेवाएँ शामिल हैं",
    servicesList: [
      "आधुनिक वीआईपी बसें",
      "लक्जरी मिनी बसें",
      "निजी कारें",
      "रेगिस्तान में रोमांच के लिए 4x4 जीपें",
      "वीआईपी लिमोजिन",
      "हवाई अड्डे से पिकअप और ड्रॉप-ऑफ़",
      "पेशेवर बहुभाषी ड्राइवर",
      "आरामदायक एयर कंडीशनिंग",
      "स्वच्छ एवं व्यवस्थित वाहन",
      "चयनित वाहनों में रेफ्रिजरेटर",
      "टीवी और मनोरंजन प्रणाली",
      "यात्रा के दौरान संगीत",
      "सुरक्षित एवं सुगम ड्राइविंग",
      "पूरे मोरक्को में 24/7 सहायता"
    ],
    featureList: [
      "आधुनिक वीआईपी बसें",
      "लक्जरी मिनी बसें",
      "निजी कारें",
      "4x4 जीपें",
      "हवाई अड्डे से घर तक छोड़ने वाली गाड़ी",
      "बहुभाषी ड्राइवर",
      "24/7 सहायता",
      "सुरक्षित ड्राइविंग"
    ],
    driversTitle: "हमारे ड्राइवरों से मिलें",
    driversText1: "हमारे ड्राइवर मोरक्को लव्स यू परिवार का हिस्सा हैं।",
    driversText2: "पेशेवर, सम्मानित, अनुभवी और मुस्कुराहट के साथ मदद के लिए हमेशा तैयार।",
    driversText3: "हमारे कई ड्राइवर कई भाषाएँ बोलते हैं और मोरक्को को गहराई से जानते हैं - जिससे हमारे मेहमानों को यात्रा के दौरान आरामदायक, सुरक्षित और जुड़ा हुआ महसूस होता है।",
    safetyTitle: "सुरक्षा और आराम पहले",
    safetyText1: "आपकी सुविधा और सुरक्षा हमारी सर्वोच्च प्राथमिकता है।",
    safetyText2: "प्रत्येक यात्रा से पहले सभी वाहनों का नियमित रूप से रखरखाव, सफाई और सावधानीपूर्वक तैयारी की जाती है।",
    safetyText3: "हम केवल विश्वसनीय पेशेवर ड्राइवरों और उच्च गुणवत्ता वाले परिवहन भागीदारों के साथ काम करते हैं।",
    categories: {
      buses: "वीआईपी बसें",
      minibuses: "लक्जरी मिनी बसें",
      cars: "निजी कारें और वीआईपी स्थानान्तरण",
      jeeps: "4x4 जीप और रेगिस्तानी परिवहन",
      meetDrivers: "हमारे ड्राइवरों से मिलें",
      videos: "परिवहन अनुभव वीडियो"
    },
    videoGalleryTitle: "वीआईपी अनुभव वीडियो",
    ctaTitle: "क्या आप आराम से मोरक्को घूमने के लिए तैयार हैं?",
    ctaSubtitle: "एलन - सीईओ और संस्थापक से सीधे बात करें",
    whatsapp: "व्हाट्सएप: +972546338757",
    moroccoLine: "मोरक्को सीधी रेखा: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "मोरक्को में लक्जरी कोषेर पर्यटन",
    pageSubtitle: "प्रामाणिक यहूदी विरासत, 100% कोषेर भोजन, लक्जरी आतिथ्य और अद्वितीय मोरक्को अनुभव।",
    introTitle: "विलासितापूर्ण यहूदी विरासत अनुभव",
    introHeading: "प्रामाणिक यहूदी मोरक्को की खोज करें",
    introText: "एक सुंदर, प्रामाणिक और प्रीमियम यात्रा अनुभव के साथ मोरक्को में यहूदी इतिहास की गहरी जड़ों की खोज करें। हम विरासत, कनेक्शन और पूर्ण आराम पर ध्यान केंद्रित करते हुए दुनिया भर में यहूदी समुदायों के लिए एक निर्बाध यात्रा प्रदान करने में विशेषज्ञ हैं।",
    introQuote: "\"मोरक्को सहिष्णुता और सह-अस्तित्व की भूमि है, जहां यहूदी विरासत को प्यार और सम्मान के साथ संरक्षित किया जाता है।\"",
    experiencesTitle: "हमारे कोषेर अनुभव शामिल हैं",
    experiencesList: [
      "100% कोषेर भोजन एवं रेस्तरां",
      "निजी कोषेर शेफ उपलब्ध है",
      "पारंपरिक मोरक्कन यहूदी व्यंजन",
      "लक्जरी 4 और 5 सितारा होटल",
      "निजी वीआईपी परिवहन",
      "बहुभाषी व्यावसायिक मार्गदर्शिकाएँ",
      "यहूदी विरासत और आराधनालय पर्यटन",
      "यहूदी कब्रिस्तान और संग्रहालय",
      "सहारा रेगिस्तान और हम्माम अनुभव",
      "24/7 व्यावसायिक सहायता"
    ],
    expFood: "100% कोषेर भोजन",
    expRestaurant: "कोषेर रेस्तरां",
    expChef: "निजी कोषेर शेफ उपलब्ध है",
    expCuisine: "पारंपरिक मोरक्कन यहूदी व्यंजन",
    expHotels: "लक्जरी होटल 4 और 5 सितारे",
    expDeluxeHotels: "अनुरोध पर डीलक्स होटल उपलब्ध हैं",
    expTransport: "निजी वीआईपी परिवहन",
    expDrivers: "पेशेवर ड्राइवर",
    expAC: "वातानुकूलित वाहन",
    expWifi: "चयनित वाहनों में वाईफाई, टीवी और रेफ्रिजरेटर",
    expGuides: "बहुभाषी व्यावसायिक मार्गदर्शिकाएँ",
    expStaff: "हिब्रू / अंग्रेजी / फ्रेंच / स्पेनिश / रूसी / जर्मन भाषी कर्मचारी",
    expHeritage: "यहूदी विरासत यात्राएँ",
    expSynagogues: "प्राचीन आराधनालय",
    expCemeteries: "यहूदी कब्रिस्तान",
    expMuseums: "यहूदी संग्रहालय",
    expSpiritual: "आध्यात्मिक एवं सांस्कृतिक अनुभव",
    expDesert: "सहारा रेगिस्तान के अनुभव",
    expHammam: "मोरक्कन हम्माम अनुभव",
    expAttractions: "पूरे मोरक्को में अद्वितीय आकर्षण",
    expAssistance: "24/7 सहायता",
    packagesTitle: "लचीले कोषेर यात्रा पैकेज",
    packagesIntro: "हम प्रत्येक यात्रा को अपने मेहमानों की आवश्यकताओं, परंपराओं, यात्रा शैली, तिथियों और अपेक्षाओं के अनुसार अनुकूलित करते हैं।",
    packageOptions: [
      "4-5 दिन",
      "7-8 दिन",
      "10-11 दिन",
      "13-14 दिन",
      "21 दिन",
      "विशेष रूप से निर्मित निजी यात्राएँ"
    ],
    package4_5: "4-5 दिन",
    package7_8: "7-8 दिन",
    package10_11: "10-11 दिन",
    package13_14: "13-14 दिन",
    package21: "21 दिन",
    packageTailor: "विशेष रूप से निर्मित निजी यात्राएँ",
    packagesQuote: "\"हम हर यात्रा को अपने मेहमानों की ज़रूरतों, परंपराओं, यात्रा शैली, तारीखों और अपेक्षाओं के अनुसार अनुकूलित करते हैं।\"",
    safetyTitle: "आरामदायक, पेशेवर और सुरक्षित यात्रा",
    safetyText: "हमारे दौरे पूरे मोरक्को में आराम, संगठन, सेवा की गुणवत्ता और पेशेवर समन्वय पर उच्च ध्यान के साथ संचालित होते हैं।",
    safetyQuote: "\"हमारे दौरे पूरे मोरक्को में आराम, संगठन, सेवा की गुणवत्ता और पेशेवर समन्वय पर अत्यधिक ध्यान देते हैं।\"",
    b2bTitle: "B2B यहूदी यात्रा भागीदारी",
    b2bText: "हम सार्थक विरासत यात्राएँ बनाने के लिए दुनिया भर में यहूदी समुदायों, आराधनालयों, रब्बियों और कोषेर टूर ऑपरेटरों के साथ साझेदारी करते हैं।",
    b2bPartnersList: "हम इनके साथ काम करते हैं: यहूदी समुदाय, आराधनालय, रब्बी, यहूदी संगठन, कोषेर टूर ऑपरेटर और दुनिया भर में ट्रैवल एजेंसियां।",
    partnerBtn: "हमारे साथ भागीदार",
    galleryTitle: "कोषेर अनुभव गैलरी",
    videosTitle: "विशेष रुप से प्रदर्शित वीडियो",
    ctaTitle: "अपनी यात्रा शुरू करने के लिए तैयार हैं?",
    msgAllan: "व्हाट्सएप पर एलन को संदेश भेजें",
    callMorocco: "मोरक्को को कॉल करें: +212 6 63 63 05 79",
    ceoContact: "एलन हैचुएल से सीधे व्हाट्सएप पर बात करें",
    exploreBtn: "कोषेर पर्यटन का अन्वेषण करें"
  },
  aria: {
    selectLanguage: "भाषा चुने",
    closeDetails: "विवरण बंद करें",
    openMenu: "मेनू खोलें",
    closeMenu: "मेनू बंद करें",
    kosherTravel: "कोषेर यात्रा मोरक्को",
    watchVideo: "मैजिक मोरक्को वीडियो देखें",
    followInstagram: "हमें इंस्टाग्राम पर फॉलो करें",
    followFacebook: "फेसबुक पर हमें का पालन करें",
    ceoMessage: "मोरक्को के सीईओ आपसे प्यार करते हैं",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "फेसबुक",
    logoAlt: "मोरक्को तुम्हें प्यार करता है लोगो",
    kingAlt: "मोरक्को के राजा",
    kosherOptionsAlt: "कोषेर विकल्प",
    moroccoLandscape: "मोरक्को परिदृश्य",
    worldCupAlt: "मोरक्को के झंडे के साथ विश्व कप ट्रॉफी",
    b2bBannerAlt: "B2B केवल टूर बैनर - व्हाट्सएप पर क्लिक करें",
    starAlt: "तारा",
    playVideo: "खेल",
    pauseVideo: "विराम",
    vipBus: "वीआईपी बस",
    drivers: "हमारे ड्राइवर",
    jewishHeritageArchitecture: "यहूदी विरासत वास्तुकला",
    jewishHeritageMorocco: "यहूदी विरासत मोरक्को",
    kosherFoodMorocco: "कोषेर भोजन मोरक्को",
    jewishHeritageExperience: "यहूदी विरासत का अनुभव",
    kosherMoroccanTable: "कोषेर मोरक्कन टेबल",
    luxuryHospitality: "विलासितापूर्ण आतिथ्य",
    kosherExperience: "कोषेर अनुभव"
  },
  forms: {
    firstName: "जैसे जॉन",
    lastName: "जैसे हरिणी",
    email: "name@example.com",
    subject: "हम कैसे मदद कर सकते हैं?",
    message: "हमें अपनी यात्रा योजनाओं के बारे में और बताएं...",
    phone: "आपका फोन नंबर",
    date: "एक तारीख चुनें",
    guests: "मेहमानों की संख्या"
  },
  common: {
    selectLanguage: "भाषा चुने",
    instagram: "Instagram",
    facebook: "फेसबुक",
    loading: "लोड हो रहा है...",
    error: "एक त्रुटि पाई गई",
    success: "सफलता!",
    noResults: "कोई परिणाम नहीं मिला",
    viewMore: "और देखें",
    viewLess: "कम देखें",
    bookNow: "अभी बुक करें",
    learnMore: "और अधिक जानें",
    contactUs: "हमसे संपर्क करें",
    close: "बंद करना",
    back: "पीछे",
    next: "अगला",
    previous: "पहले का",
    search: "खोज...",
    filter: "फ़िल्टर",
    sort: "क्रम से लगाना",
    price: "कीमत",
    duration: "अवधि",
    languages: {
      english: "अंग्रेज़ी",
      american: "अमेरिकी",
      australia: "ऑस्ट्रेलिया",
      canada: "कनाडा",
      french: "फ़्रेंच",
      spanish: "स्पैनिश",
      hebrew: "यहूदी",
      arabic: "धन्यवाद",
      german: "जर्मन",
      italian: "इतालवी",
      japanese: "जापानी",
      chinese: "चीनी",
      korean: "कोरियाई",
      vietnamese: "वियतनामी",
      russian: "रूसी",
      en: "अंग्रेज़ी",
      "en-US": "अमेरिकी",
      "en-AU": "ऑस्ट्रेलिया",
      "en-CA": "कनाडा",
      fr: "फ़्रेंच",
      es: "स्पैनिश",
      he: "यहूदी",
      ar: "धन्यवाद",
      de: "जर्मन",
      it: "इतालवी",
      ja: "जापानी",
      zh: "चीनी",
      ko: "कोरियाई",
      vi: "वियतनामी",
      ru: "रूसी",
      hi: "हिन्दी"
    }
  },
  whatsapp: {
    greeting: "नमस्ते मोरक्को आपसे प्यार करता है! 🌟",
    bookPackage: "मैं निम्नलिखित पैकेज बुक करना चाहूंगा:",
    packageInfo: "📦 पैकेज:",
    duration: "⏱️ अवधि:",
    price: "💰 कीमत:",
    bookingRequest: "कृपया मुझे उपलब्धता और अगले चरण बताएं। धन्यवाद!",
    cityTrip: "मैं {शहर} की यात्रा की योजना बनाना चाहूंगा। क्या आप मेरी मदद कर सकते हैं?",
    silverPackage: "मुझे सिल्वर वर्ल्ड कप पैकेज में दिलचस्पी है",
    goldPackage: "मुझे गोल्ड वर्ल्ड कप पैकेज में दिलचस्पी है",
    diamondPackage: "मुझे डायमंड वर्ल्ड कप वीआईपी पैकेज में दिलचस्पी है",
    worldCupSecure: "नमस्ते, मैं मोरक्को 2030 के लिए अपना स्थान सुरक्षित करना चाहता हूँ।",
    kosherInquiry: "मुझे आपके कोषेर मोरक्को यात्रा पैकेज में दिलचस्पी है।",
    customPackage: "मैं हमारे समूह के लिए एक कस्टम पैकेज बनाना चाहूंगा।",
    businessInquiry: "मुझे वीआईपी बिजनेस ट्रैवल सेवाओं में दिलचस्पी है।"
  },
  blog_posts: {
    post1: {
      title: "मोरक्को में खोजने के लिए 10 छिपे हुए रत्न",
      author: "फातिमा हसन",
      date: "15 मार्च 2024",
      category: "यात्रा दिग्दर्शक",
      excerpt: "मोरक्को के कम-ज्ञात स्थलों और छिपे हुए खजानों की खोज करें जिन्हें अधिकांश पर्यटक चूक जाते हैं। गुप्त पहाड़ी गांवों से लेकर प्राचीन तटीय क्षेत्रों तक, प्रामाणिक मोरक्को का अन्वेषण करें।",
      content: "मोरक्को सिर्फ माराकेच और कैसाब्लांका से कहीं अधिक है। यह व्यापक मार्गदर्शिका छुपे हुए रत्नों को उजागर करती है..."
    },
    post2: {
      title: "मोरक्को घूमने का सबसे अच्छा समय: एक संपूर्ण गाइड",
      author: "अहमद बेन्नानी",
      date: "10 मार्च 2024",
      category: "योजना",
      excerpt: "अपनी मोरक्को यात्रा की योजना बना रहे हैं? यात्रा करने के लिए सर्वोत्तम मौसमों के बारे में जानें, मौसम के अनुसार क्या उम्मीद करें और पूरे वर्ष अपनी यात्रा का अधिकतम लाभ कैसे उठाएं।",
      content: "मोरक्को की यात्रा के लिए सही समय का चयन आपके यात्रा अनुभव पर महत्वपूर्ण प्रभाव डाल सकता है। यहां हमारी पूरी गाइड है..."
    },
    post3: {
      title: "मोरक्कन व्यंजन: एक पाककला साहसिक",
      author: "लैला रहीम",
      date: "5 मार्च 2024",
      category: "भोजन संस्कृति",
      excerpt: "मोरक्को के माध्यम से पाक यात्रा पर निकलें। उन समृद्ध स्वादों, पारंपरिक व्यंजनों और भोजन अनुभवों की खोज करें जो मोरक्कन भोजन को विश्व प्रसिद्ध बनाते हैं।",
      content: "मोरक्कन व्यंजन अरब, बर्बर, अंडालूसी और अफ्रीकी प्रभावों का मिश्रण है। प्रत्येक व्यंजन मोरक्को की विविध विरासत की कहानी कहता है..."
    },
    post4: {
      title: "एक पेशेवर की तरह मोरक्कन बाज़ारों में सौदेबाज़ी कैसे करें",
      author: "यूसुफ अलाउई",
      date: "28 फ़रवरी 2024",
      category: "यात्रा युक्तियाँ",
      excerpt: "मोरक्को के बाज़ारों और बाज़ारों में मोलभाव करने की कला में महारत हासिल करें। सर्वोत्तम सौदे प्राप्त करने के लिए सांस्कृतिक शिष्टाचार, बातचीत की रणनीति और अंदरूनी युक्तियाँ सीखें।",
      content: "मोरक्कन बाज़ारों में सौदेबाज़ी महज़ एक लेन-देन नहीं है; यह एक सांस्कृतिक आदान-प्रदान है। यहां बताया गया है कि इसे सम्मानपूर्वक और प्रभावी ढंग से कैसे किया जाए..."
    },
    post5: {
      title: "एटलस पर्वत पर ट्रैकिंग: आपको क्या जानना चाहिए",
      author: "अहमद बेन्नानी",
      date: "20 फ़रवरी 2024",
      category: "साहसिक काम",
      excerpt: "पैदल राजसी एटलस पर्वत का अन्वेषण करें। ट्रैकिंग मार्गों, क्या पैक करना है, ऊंचाई पर विचार और अपने पर्वतीय साहसिक कार्य के लिए सर्वोत्तम समय के बारे में विशेषज्ञ की सलाह प्राप्त करें।",
      content: "एटलस पर्वत उत्तरी अफ्रीका में सबसे लुभावने परिदृश्य पेश करते हैं। चाहे आप अनुभवी यात्री हों या नौसिखिया..."
    },
    post6: {
      title: "डेजर्ट सफारी: एक अविस्मरणीय अनुभव",
      author: "फातिमा हसन",
      date: "15 फ़रवरी 2024",
      category: "साहसिक काम",
      excerpt: "मोरक्को के सहारा रेगिस्तान के जादू का अनुभव करें। ऊँट ट्रैकिंग, कैनवास टेंट के नीचे तारों भरी रातें और सूर्योदय के क्षण आप कभी नहीं भूलेंगे।",
      content: "सहारा रेगिस्तान मोरक्को की आत्मा का प्रतिनिधित्व करता है। एक रेगिस्तानी सफ़ारी महज़ एक साहसिक कार्य से कहीं अधिक है; यह एक आध्यात्मिक यात्रा है..."
    },
    post7: {
      title: "सांस्कृतिक शिष्टाचार: मोरक्को की परंपराओं का सम्मान करना",
      author: "लैला रहीम",
      date: "10 फ़रवरी 2024",
      category: "संस्कृति",
      excerpt: "अपनी यात्रा के दौरान मोरक्को के लोगों और परंपराओं के साथ सम्मानपूर्वक जुड़ने के लिए आवश्यक सांस्कृतिक मानदंडों, रीति-रिवाजों और शिष्टाचार को सीखें।",
      content: "मोरक्को की यात्रा करते समय स्थानीय रीति-रिवाजों को समझना और उनका सम्मान करना महत्वपूर्ण है। यह मार्गदर्शिका आवश्यक सांस्कृतिक प्रथाओं को शामिल करती है..."
    },
    post8: {
      title: "मोरक्को में फ़ोटोग्राफ़ी: जादू को कैद करना",
      author: "यूसुफ अलाउई",
      date: "5 फरवरी 2024",
      category: "फोटोग्राफी",
      excerpt: "मोरक्को में सबसे अधिक फोटोजेनिक स्थानों की खोज करें और परिदृश्य, लोगों और संस्कृति की आश्चर्यजनक छवियों को कैप्चर करने के लिए पेशेवर युक्तियों की खोज करें।",
      content: "मोरक्को फोटोग्राफरों का स्वर्ग है। नीले मदीना से लेकर सुनहरे रेगिस्तान तक, हर कोना अविश्वसनीय फोटो अवसर प्रदान करता है..."
    }
  },
  jobs: {
    title: "करियर और अवसर",
    intro: "MoroccoLovesYou टीम में शामिल हों और लक्जरी यात्रा में अपना भविष्य बनाएं",
    workWith: "प्यार, देखभाल और उत्कृष्टता के साथ काम करें",
    introText: "हम भावुक, समर्पित व्यक्तियों की तलाश कर रहे हैं जो विश्व स्तरीय यात्रा अनुभव प्रदान करने के हमारे दृष्टिकोण को साझा करते हों। हमारी बढ़ती टीम में शामिल हों और किसी विशेष चीज़ का हिस्सा बनें।",
    openPositions: "खुले स्थानों",
    requirements: "आवश्यकताएं:",
    readyJoin: "हमसे जुड़ने के लिए तैयार हैं?",
    sendCV: "अपना CV Careers@moroccolovesyou.com पर भेजें",
    instructions: "एक संक्षिप्त कवर लेटर शामिल करें जिसमें बताया गया हो कि आप मोरक्को लव्स यू टीम में क्यों शामिल होना चाहते हैं।",
    emailCv: "सीईओ को सीवी ईमेल करें",
    chatCeo: "व्हाट्सएप पर सीईओ से चैट करें",
    job1: {
      title: "बहुभाषी व्यावसायिक टूर गाइड",
      type: "पूर्णकालिक/मौसमी",
      location: "माराकेच/फ़ेस/मोरक्को-व्यापी",
      description: "हम भावुक, जानकार और कहानी सुनाने वाले मार्गदर्शकों की तलाश कर रहे हैं जो हमारे वीआईपी मेहमानों के लिए मोरक्को को जीवंत बना सकें। आपकी भूमिका में प्रीमियम पर्यटन का नेतृत्व करना, सांस्कृतिक अंतर्दृष्टि साझा करना और मेहमानों की संतुष्टि सुनिश्चित करना शामिल है।",
      req1: "कम से कम 2 भाषाओं में पारंगत (फ्रेंच, स्पेनिश, अंग्रेजी, हिब्रू, जर्मन, रूसी, या इतालवी पसंदीदा)",
      req2: "मोरक्को के इतिहास, संस्कृति और भूगोल का गहन ज्ञान",
      req3: "पेशेवर, आकर्षक और उत्कृष्ट ग्राहक सेवा कौशल",
      req4: "रेगिस्तान ट्रैकिंग और बाहरी गतिविधियों के लिए शारीरिक फिटनेस"
    },
    job2: {
      title: "वीआईपी कार्यकारी चालक",
      type: "पूरा समय",
      location: "मोरक्को-व्यापी",
      description: "आधुनिक हाई-एंड मर्सिडीज वाहन चलाने वाली हमारी लक्जरी परिवहन टीम में शामिल हों। आप वीआईपी स्थानान्तरण प्रदान करेंगे, अतिथि आराम और सुरक्षा सुनिश्चित करेंगे, और व्यावसायिकता और आतिथ्य के साथ हमारे ब्रांड का प्रतिनिधित्व करेंगे।",
      req1: "उत्कृष्ट ड्राइविंग रिकॉर्ड के साथ वैध ड्राइवर का लाइसेंस (10+ वर्ष के अनुभव को प्राथमिकता)",
      req2: "अंग्रेजी में प्रवाह (अतिरिक्त भाषाओं का लाभ)",
      req3: "पेशेवर उपस्थिति और विनम्र व्यवहार",
      req4: "मोरक्को की सड़कों और मार्गों का ज्ञान; जीपीएस/नेविगेशन अनुभव"
    },
    job3: {
      title: "ग्राहक अनुभव समन्वयक",
      type: "पूरा समय",
      location: "रिमोट/हाइब्रिड (Fes कार्यालय)",
      description: "लक्जरी कस्टम यात्रा कार्यक्रम आयोजित करने, अतिथि संचार प्रबंधित करने और निर्बाध यात्रा समन्वय सुनिश्चित करने में हमारे सीईओ कार्यालय का समर्थन करें। यह भूमिका संगठित, विस्तार-उन्मुख पेशेवरों के लिए आदर्श है।",
      req1: "उत्कृष्ट संगठनात्मक और संचार कौशल",
      req2: "यात्रा, आतिथ्य, या ग्राहक सेवा का अनुभव",
      req3: "अंग्रेजी में निपुण; अतिरिक्त भाषाएँ एक बोनस",
      req4: "बुकिंग सिस्टम और माइक्रोसॉफ्ट ऑफिस सुइट में दक्षता"
    }
  },
  testimonials_data: {
    intro: "हमारे संतुष्ट मेहमानों से मिलें जिन्होंने हमारी सेवाओं के माध्यम से मोरक्को का अनुभव किया है",
    testi1: {
      name: "सारा जॉनसन",
      title: "लंदन, यूके",
      text: "मोरक्को लव्स यू ने मेरी सपनों की यात्रा को हकीकत बना दिया! लक्जरी होटलों से लेकर प्रामाणिक अनुभवों तक, हर विवरण पूरी तरह से व्यवस्थित था। सेवा बेजोड़ है. मैं पहले से ही अपनी वापसी यात्रा की योजना बना रहा हूँ!",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      rating: 5
    },
    testi2: {
      name: "माइकल चेन",
      title: "सिंगापुर",
      text: "एक व्यापारिक यात्री के रूप में, मैं व्यावसायिकता और अनुकूलन से प्रभावित हुआ। पहले दिन से ही वीआईपी ट्रीटमेंट, वैयक्तिकृत यात्रा कार्यक्रम और त्रुटिहीन लॉजिस्टिक्स। कार्यकारी यात्रा के लिए अत्यधिक अनुशंसित।",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      rating: 5
    },
    testi3: {
      name: "एम्मा विल्सन",
      title: "सिडनी, ऑस्ट्रेलिया",
      text: "रेगिस्तान का अनुभव जादुई था! तारों के नीचे सोना, ऊँट की ट्रैकिंग, और मोरक्को के आतिथ्य की गर्माहट सभी उम्मीदों से बढ़कर थी। आजीवन यादें बनाने के लिए धन्यवाद!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      rating: 5
    },
    testi4: {
      name: "जेम्स रोड्रिग्ज",
      title: "मैड्रिड, स्पेन",
      text: "पारिवारिक यात्रा की योजना बनाना तनावपूर्ण हो सकता है, लेकिन मोरक्को लव्स यू ने सब कुछ शानदार ढंग से संभाला। सभी उम्र के लोगों के लिए सुरक्षित, शैक्षिक और मनोरंजक। हमारे बच्चे अभी भी मदीना यात्राओं के बारे में बात करते हैं!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      rating: 5
    },
    testi5: {
      name: "अन्ना मुलर",
      title: "बर्लिन, जर्मनी",
      text: "मैंने सांस्कृतिक प्रामाणिकता और स्थानीय परंपराओं के प्रति दिखाए गए सम्मान की सराहना की। यह सिर्फ पर्यटन नहीं था; यह एक वास्तविक सांस्कृतिक विसर्जन था। पूरी टीम को शाबाशी!",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      rating: 5
    },
    testi6: {
      name: "डेविड थॉम्पसन",
      title: "टोरंटो, कनाडा",
      text: "The accessibility for seniors was exceptional. आरामदायक गति, सहायक मार्गदर्शक और लक्जरी आवास ने मेरे दादा-दादी को अविश्वसनीय रूप से खुश किया। A service that truly cares.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      rating: 5
    },
    testi7: {
      name: "लिसा एंडरसन",
      title: "न्यूयॉर्क, यूएसए",
      text: "भोजन प्रेमी यहाँ! पाक अनुभव उत्तम थे। प्रत्येक भोजन ने एक कहानी बताई, प्रत्येक मार्गदर्शक ने वास्तविक जुनून दिखाया। मोरक्को का स्वाद हमेशा मेरे साथ रहेगा।",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      rating: 5
    },
    testi8: {
      name: "मार्कस स्मिथ",
      title: "लॉस एंजिल्स, यूएसए",
      text: "रोमांच से भरपूर लेकिन शानदार - बिल्कुल वही जो मैं तलाश रहा था। एटलस ट्रैकिंग, रेगिस्तानी सफ़ारी, सभी वीआईपी आराम के साथ। हर पैसे के लायक!",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      rating: 5
    },
    testi9: {
      name: "सोफी लॉरेंट",
      title: "पेरिस, फ़्रांस",
      text: "असाधारण रोमांस यात्रा! सहारा में सूर्यास्त, माराकेच का दृश्य दिखाने वाला निजी रात्रिभोज, और हर जगह चौकस सेवा। मोरक्को लव्स यू वास्तव में उनके नाम के अनुरूप है।",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      rating: 5
    }
  },
  gallery_categories: {
    food: "पाककला अनुभव",
    destinations: "स्थल",
    kosher: "कोषेर",
    transport: "वीआईपी परिवहन"
  },
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  }
};

export default hi;
